<template>
    <div class="wrapper-frame">
        <div class="wrapper-frame__loading" v-if="loading">
            <p class="mb-2">{{__('loading...')}}</p>
            <div class="loading-body" ref="frame_loading">
                <p>{{__('Please wait 10 seconds or refresh the page')}}</p>
                <BaseButton
                    @click="reloadPage"
                    :loading="reloadDisabled"
                >
                    <span>{{__('Reload Now')}}</span>
                </BaseButton>
            </div>
        </div>
        <div v-else-if="stubOrientation" class="stub-orientation">
                <div class="stub-orientation__icon">
                    <svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2803_1121)">
                            <path d="M56.0117 0.23999C58.2105 0.23999 59.9924 2.02195 59.9924 4.22068V103.732C59.9924 105.931 58.2104 107.713 56.0117 107.713H4.26584C2.06708 107.713 0.285156 105.931 0.285156 103.732V4.22068C0.285156 2.02191 2.06712 0.23999 4.26584 0.23999L56.0117 0.23999ZM56.0117 2.89378H4.26584C3.53342 2.89378 2.93893 3.48827 2.93893 4.2207V103.732C2.93893 104.465 3.53342 105.059 4.26584 105.059H56.0117C56.7441 105.059 57.3386 104.465 57.3386 103.732V4.2207C57.3386 3.48827 56.7441 2.89378 56.0117 2.89378Z" fill="#026EED"/>
                            <path d="M50.7047 12.1815C52.9027 12.1815 54.6847 13.9634 54.6847 16.1621V86.4834C54.6847 88.6822 52.9027 90.4641 50.7047 90.4641H9.57367C7.37567 90.4641 5.59375 88.6821 5.59375 86.4834V16.1621C5.59375 13.9634 7.37571 12.1815 9.57367 12.1815H50.7047ZM50.7047 14.8352H9.57367C8.84125 14.8352 8.24675 15.4297 8.24675 16.1622V86.4834C8.24675 87.2158 8.84125 87.8103 9.57367 87.8103H50.7047C51.4372 87.8103 52.0309 87.2158 52.0309 86.4834V16.1622C52.0309 15.4297 51.4372 14.8352 50.7047 14.8352Z" fill="#026EED"/>
                            <path d="M36.1102 6.87372C36.8426 6.87372 37.4371 7.46821 37.4371 8.20063C37.4371 8.93305 36.8426 9.52755 36.1102 9.52755H24.1687C23.4363 9.52755 22.8418 8.93305 22.8418 8.20063C22.8418 7.46821 23.4363 6.87372 24.1687 6.87372H36.1102Z" fill="#026EED"/>
                            <path d="M30.1388 91.7908C33.07 91.7908 35.4464 94.1672 35.4464 97.0984C35.4464 100.029 33.07 102.405 30.1388 102.405C27.2083 102.405 24.832 100.029 24.832 97.0984C24.832 94.1672 27.2085 91.7908 30.1388 91.7908ZM30.1388 94.4446C28.6733 94.4446 27.4858 95.632 27.4858 97.0984C27.4858 98.5647 28.6733 99.7521 30.1388 99.7521C31.6052 99.7521 32.7926 98.5647 32.7926 97.0984C32.7926 95.632 31.6052 94.4446 30.1388 94.4446Z" fill="#026EED"/>
                            <path d="M103.778 48.0056C105.976 48.0056 107.757 49.7868 107.757 51.9855V103.731C107.757 105.93 105.976 107.712 103.778 107.712H62.6465C61.9141 107.712 61.3203 107.118 61.3203 106.385C61.3203 105.653 61.9141 105.058 62.6465 105.058H103.778C104.51 105.058 105.104 104.464 105.104 103.731V51.9854C105.104 51.253 104.51 50.6585 103.778 50.6585H62.6465C61.9141 50.6585 61.3203 50.064 61.3203 49.3316C61.3203 48.5992 61.9141 48.0054 62.6465 48.0054L103.778 48.0056Z" fill="#00AEFF"/>
                            <path d="M91.8367 53.312C94.0346 53.312 95.8166 55.094 95.8166 57.2927V98.4238C95.8166 100.623 94.0346 102.404 91.8367 102.404H62.6465C61.9141 102.404 61.3203 101.81 61.3203 101.078C61.3203 100.345 61.9141 99.7506 62.6465 99.7506H91.8367C92.5691 99.7506 93.1636 99.1561 93.1636 98.4237V57.2926C93.1636 56.5602 92.5691 55.9657 91.8367 55.9657H62.6465C61.9141 55.9657 61.3203 55.3712 61.3203 54.6388C61.3203 53.9064 61.9141 53.3119 62.6465 53.3119L91.8367 53.312Z" fill="#00AEFF"/>
                            <path d="M99.7976 70.5613C100.53 70.5613 101.125 71.1558 101.125 71.8882V83.8297C101.125 84.5621 100.53 85.1566 99.7976 85.1566C99.0652 85.1566 98.4707 84.5621 98.4707 83.8297V71.8882C98.4707 71.1558 99.0652 70.5613 99.7976 70.5613Z" fill="#00AEFF"/>
                            <path d="M106.431 36.0646C107.613 36.0646 108.206 37.4935 107.37 38.3294C105.158 40.5408 102.948 42.7517 100.735 44.9631C100.218 45.4819 99.377 45.4819 98.8597 44.9631L92.2252 38.3294C91.3893 37.4935 91.9816 36.0646 93.1638 36.0646H106.431ZM103.229 38.7177H96.3661L99.7973 42.1489C100.59 41.3558 101.383 40.5626 102.176 39.7701C103.076 38.8705 102.724 39.2207 103.229 38.7177Z" fill="#01DF72"/>
                            <path d="M63.9721 6.87372C81.6777 6.87372 96.824 19.3526 100.357 36.4803C100.506 37.1985 100.044 37.9002 99.3263 38.0479C98.6081 38.1963 97.9065 37.7345 97.758 37.0164C94.4782 21.1159 80.4137 9.52847 63.9734 9.52847C63.241 9.52847 62.6465 8.93398 62.6465 8.20155C62.6465 7.46913 63.241 6.87464 63.9734 6.87464L63.9721 6.87372Z" fill="#01DF72"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2803_1121">
                                <rect width="107.664" height="107.52" fill="white" transform="translate(0.240234 0.23999)"/>
                            </clipPath>
                        </defs>
                    </svg>

                </div>
                <p class="stub-orientation__title">{{__('Game is not support portrait mode.')}}</p>

                <p class="stub-orientation__subtitle">{{__('Please switch to landscape mode and reload page.')}}</p>

                <BaseButton
                    :loading="reloadDisabled"
                    @click="reloadPage"
                >
                    <span>{{__('Reload Now')}}</span>
                </BaseButton>
        </div>
        <div v-else>
            <GameIframeGame
                    style="z-index: 102;"
                    v-bind:rules_game_modal.sync="rules_game_modal"
                    @favoriteChanged="changedFavorite"
                    v-bind:game="game"
                    @openModal="openModal"
                    @openEmoji="openEmoji"
                    :arr_emoji="arr_emoji"
                    :my_emoji.sync="my_emoji"
                    :add_class_emoji.sync="add_class_emoji"
            ></GameIframeGame>
            <div class="modal-exit-mobile" ref="modal_exit">
                <BaseButton
                    v-if="game.tournament_id"
                    class_btn="btn-liteGrey"
                    :to="{name: 'tournament', params: {'id': game.tournament_id, lang: $store.getters.getLang}}"
                    :disabled="submitDisabled"
                >
                    <span>{{__('Leave the Game')}}</span>
                </BaseButton>

                <BaseButton
                    v-else
                    class_btn="btn-liteGrey"
                    :to="{name: 'game', params: {'id': game.url, lang: $store.getters.getLang}}"
                    :disabled="submitDisabled"
                >
                    <span>{{__('Leave the Game')}}</span>
                </BaseButton>
            </div>

            <div class="modal-emoji" ref="modal_emoji">
                <div v-if="!auth.pro" class="block-notpro">{{__('only for pro account')}}</div>
<!--                <VueSlickCarousel-->
<!--                    v-bind="settings"-->
<!--                >-->
                    <div class="emoji-item" v-for="(item, key) in arr_emoji" :key="key">
                        <img v-if="auth.pro && submitEmoji" :src="item.img" alt="/" @click="sendEmoji(item)">
                        <img v-else-if="auth.pro && !submitEmoji" class="img-disabled" :src="item.img" alt="/">
                        <img v-else class="img-grey" :src="item.img" alt="/">
                    </div>
<!--                </VueSlickCarousel>-->
            </div>
            <GameIframe v-bind:iframe="game" :focus.sync="focus"></GameIframe>
        </div>


<!--        <ModalDefault class_name="info-window" v-if="modal_result">-->
<!--          <div class="modal-rematch" v-if="game">-->
          <div class="modal-rematch" v-if="game && modal_result" data-aos="fade-down" data-aos-duration="800" style="z-index: 100">
<!--            <div>-->
<!--              <div v-if="game.type == 1" class="timer">-->
<!--                <div class="wrapper">-->
<!--                    <div class="pie spinner"></div>-->
<!--                    <div class="pie filler"></div>-->
<!--                    <div class="mask"></div>-->
<!--                </div>-->
<!--                <img :src="'/assets/games/'+((game.logo) ? game.logo : 'default.svg')">-->
<!--                <span>{{time}}</span>-->
<!--              </div>-->

<!--              <div class="wrap-img">-->
<!--                <router-link :to="{name: 'game', params: {id: game.id}}"  class="mb-0">-->
<!--                  <img :src="game.logo">-->
<!--                </router-link>-->
<!--              </div>-->
<!--            </div>-->
            <div class="wrap-line-time">
<!--              <div v-if="game.type == 1" class="info line-time"></div>-->
              <div class="info line-time"></div>
            </div>

            <div class="block-result">
                <div class="block-result__left">
                    <span v-if="modal_result.result_user == 1" class="text-win">
                        <p>{{__('Сongratulations !')}}</p>
                        {{__('YOUR WIN !')}}
                    </span>
                    <span v-else-if="modal_result.result_user== 2" class="text-loose">
                        <p>{{__('Unfortunately !')}}</p>
                        {{__('Your defeat')}}
                    </span>
                    <span v-else-if="modal_result.result_user== 3" class="text-draw">
                        <p>{{__('Unfortunately !')}}</p>
                        {{__('Draw in the Game!')}}
                    </span>
                    <div class="block-info">
<!--                        <p>Your result:</p>-->
                        <div class="block-info__item">
                            <p class="item-title">{{__('Game Time')}}</p>
                            <span class="item-subtitle">{{modal_result.time_second}} {{__('sec')}}</span>
                        </div>

                        <div class="block-info__item">
                            <p class="item-title">{{__('Bonus rating')}}</p>
                            <span class="item-subtitle">
                                <p style="color: #FFBA49">+{{modal_result.rating_points}}</p>

                                <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.939 6.31406C13.2695 7.46315 14.0304 8.8721 14.0304 10.8044C14.0304 14.83 10.8853 18 7.0253 18C3.16187 18 0 14.8278 0 10.8044C0 8.5885 0.480177 7.21903 1.88974 4.94275C2.33576 4.22248 3.41876 4.48478 3.50267 5.33341C3.57806 6.09594 3.80957 6.74502 4.14688 7.24265C3.9219 4.55371 5.0893 1.52961 7.96782 0.0929165C8.63424 -0.239701 9.37788 0.372255 9.20448 1.11058C8.75508 3.02401 9.21811 4.05343 10.4285 5.16241C10.458 5.18946 10.6088 5.30079 10.8082 5.44802C11.1694 5.71466 11.6901 6.09907 11.939 6.31406ZM2.2983 7.89878C2.05121 8.47402 1.75397 9.16602 1.75397 10.8046C1.75397 13.8273 4.12255 16.2036 7.02547 16.2036C9.92314 16.2036 12.2768 13.8314 12.2768 10.8046C12.2768 9.45419 11.7723 8.51999 10.8087 7.68782C10.6566 7.55646 10.3001 7.29126 9.96455 7.04164C9.64728 6.80563 9.34874 6.58354 9.25941 6.5017C8.09741 5.43701 7.38701 4.30324 7.29052 2.79144C6.703 3.37814 5.35298 5.20206 6.11391 8.81167C6.23187 9.37124 5.81561 9.89957 5.25676 9.89957C4.14796 9.89957 3.05192 9.03092 2.38207 7.7012C2.35519 7.76635 2.32709 7.83177 2.2983 7.89878Z" fill="#FFBA49"/>
                                </svg>
                            </span>
                        </div>

                        <div class="block-info__item">
                            <p class="item-title">{{__('To your money')}}</p>
                            <span class="item-subtitle">
                                <p v-if="modal_result.result_user== 1">+{{modal_result.amount}}</p>
                                <p v-else-if="modal_result.result_user== 2" class="error--text">-{{modal_result.amount}}</p>
                                <p v-else-if="modal_result.result_user== 3">{{modal_result.amount}}</p>

                                <!--<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                                    <!--<g style="mix-blend-mode:luminosity">-->
                                    <!--<g style="mix-blend-mode:luminosity" opacity="0.5">-->
                                    <!--<path d="M4.53254 2.51367C4.53252 2.36003 4.49207 2.20909 4.41524 2.07604C4.33841 1.94299 4.22792 1.8325 4.09486 1.75568L4.09481 1.75566V1.75564L1.25157 0.113753C1.12519 0.0396783 0.981422 0.000427953 0.834928 0C0.695348 0.000577613 0.558126 0.0360355 0.435738 0.10315C0.160023 0.252463 -2.65524e-05 0.553272 3.30411e-09 0.866822L0.000274499 4.11936L2.99999 2.38764C3.06638 2.34932 3.14168 2.32915 3.21833 2.32915C3.29498 2.32915 3.37028 2.34932 3.43666 2.38764L3.43886 2.38892C3.50525 2.42724 3.56038 2.48236 3.59871 2.54875C3.63704 2.61513 3.65722 2.69043 3.65723 2.76708C3.65724 2.84373 3.63706 2.91903 3.59875 2.98542C3.56043 3.05181 3.50531 3.10694 3.43894 3.14527L0.482879 4.85256C0.336171 4.93729 0.214349 5.05915 0.129657 5.20588C0.0449648 5.35261 0.000385584 5.51905 0.000399112 5.68846L0.000772078 10.3692L4.31547 7.8739C4.3816 7.83565 4.43651 7.78068 4.47468 7.7145C4.51285 7.64833 4.53294 7.57328 4.53293 7.49688L4.53254 2.51365V2.51367ZM3.64725 2.01402L3.65649 2.00866L3.65708 2.00896L3.64725 2.01402Z" fill="white"/>-->
                                    <!--</g>-->
                                    <!--<g style="mix-blend-mode:luminosity" opacity="0.6">-->
                                    <!--<path d="M1.5349 11.7537L4.49143 13.4634C4.63816 13.5482 4.80464 13.593 4.97413 13.593C5.14363 13.5931 5.31016 13.5486 5.45697 13.4639L9.51354 11.1235L5.18836 8.63175C5.12214 8.5936 5.04704 8.57354 4.97061 8.57361C4.89418 8.57367 4.81912 8.59385 4.75295 8.63211L0.445173 11.1235L0.435638 11.1289C0.303471 11.2043 0.1936 11.3133 0.117177 11.4449C0.0407536 11.5764 0.000498712 11.7259 0.000498738 11.878L0.000488281 15.1351C0.000488281 15.4294 0.139612 15.715 0.389502 15.8705C0.517931 15.9522 0.666344 15.9969 0.818492 15.9998C0.970639 16.0027 1.12066 15.9637 1.25212 15.887L4.09522 14.2449L1.09436 12.5104C1.0282 12.4721 0.973267 12.4171 0.93508 12.3509C0.896894 12.2848 0.876797 12.2097 0.87681 12.1333C0.876824 12.0568 0.896952 11.9818 0.935173 11.9156C0.973395 11.8494 1.02836 11.7944 1.09455 11.7562L1.09917 11.7535C1.16541 11.7153 1.24056 11.6952 1.31706 11.6952C1.39355 11.6952 1.46869 11.7154 1.5349 11.7537Z" fill="white"/>-->
                                    <!--</g>-->
                                    <!--<g style="mix-blend-mode:luminosity" opacity="0.35">-->
                                    <!--<path d="M13.6643 7.27912L10.816 5.63526V9.10851C10.816 9.18516 10.7958 9.26046 10.7575 9.32684C10.7192 9.39322 10.664 9.44833 10.5977 9.48665L10.5955 9.48788C10.5292 9.52619 10.4539 9.54635 10.3772 9.54634C10.3006 9.54633 10.2253 9.52616 10.159 9.48784C10.0926 9.44952 10.0375 9.3944 9.99917 9.32803C9.96085 9.26166 9.94068 9.18638 9.94068 9.10974V5.68129C9.94068 5.51187 9.89609 5.34543 9.81138 5.19871C9.72668 5.05198 9.60484 4.93014 9.45813 4.84542L5.4082 2.50684V7.4949C5.4082 7.5714 5.42836 7.64655 5.46664 7.71279C5.50491 7.77903 5.55996 7.83401 5.62625 7.87221L9.94068 10.3585L9.94678 10.3623C10.0774 10.4418 10.227 10.4848 10.38 10.4866C10.5329 10.4884 10.6835 10.449 10.816 10.3725L13.666 8.72516C13.7929 8.65175 13.8982 8.54624 13.9713 8.41923C14.0444 8.29223 14.0829 8.14821 14.0827 8.00165C14.0825 7.85509 14.0438 7.71116 13.9703 7.58433C13.8969 7.4575 13.7914 7.35224 13.6643 7.27912H13.6643Z" fill="white"/>-->
                                    <!--</g>-->
                                    <!--</g>-->
                                <!--</svg>-->
                                <img width="20px" v-if="modal_result.wallet == 1" src="/dist/images/frontend/money.svg" alt="">
                                <img width="20px" v-else src="/dist/images/frontend/light-coin.svg" alt />

                            </span>
                        </div>

<!--                        <span class="block-rating">-->
<!--                            <img  src="/dist/images/frontend/fire.svg" alt />-->
<!--                            +{{modal_result.rating_points}}-->
<!--                        </span>-->
<!--                        <span class="block-coin">-->
<!--                            <span v-if="modal_result.wallet == 1" class="block-coin__real">-->
<!--                                <img  src="/dist/images/frontend/money.svg" alt />-->
<!--                                <span v-if="modal_result.result_user== 1">+{{modal_result.amount}}</span>-->
<!--                                <span v-else-if="modal_result.result_user== 2" class="error&#45;&#45;text">-{{modal_result.amount}}</span>-->
<!--                                <span v-else-if="modal_result.result_user== 3">{{modal_result.amount}}</span>-->
<!--                            </span>-->
<!--                            <span v-else class="block-coin__lite">-->
<!--                                <img class="pic" src="/dist/images/frontend/light-coin.svg" alt />-->
<!--                                <span v-if="modal_result.result_user== 1">+{{modal_result.amount}}</span>-->
<!--                                <span v-else-if="modal_result.result_user== 2" class="error&#45;&#45;text">-{{modal_result.amount}}</span>-->
<!--                                <span v-else-if="modal_result.result_user== 3">{{modal_result.amount}}</span>-->
<!--                            </span>-->
<!--                        </span>-->
                    </div>
                </div>

              <div class="btn-window d-flex">
<!--                <v-btn -->
<!--                    class="btn-info-ok btn-cab white&#45;&#45;text"-->
<!--                    :loading="submitDisabled"-->
<!--                    text-->
<!--                    v-on:click="gameRematch">-->
<!--                  {{__('Rematch')}}-->
<!--                </v-btn>-->
<!--                <v-btn-->
<!--                  class="btn-secondary"-->
<!--                  text-->
<!--                  :to="{name: 'game', params: {'id': game.id}}"-->
<!--                  :disabled="submitDisabled"-->
<!--                >-->
<!--                  {{__('Leave the Game')}}-->
<!--                </v-btn>-->
                  <div class="wrap-btn-rematch" v-if="game.type != 3 && modal_result.rematch == 1">
                      <BaseButton
                          :loading="submitDisabled"
                          v-on:click="((game.type == 1) ? gameRematch() : sendInvitation())">
                          <span>{{__('Rematch')}}</span>
                      </BaseButton>
                  </div>



                  <div class="wrap-btn-leave">
                      <BaseButton
                          v-if="game.tournament_id"
                          class_btn="btn-liteGrey"
                          :to="{name: 'tournament', params: {'id': game.tournament_id, lang: $store.getters.getLang}}"
                          :disabled="submitDisabled"
                      >
                          <span>{{__('Leave the Game')}}</span>
                      </BaseButton>

                      <BaseButton
                          v-else
                          class_btn="btn-liteGrey"
                          :to="{name: 'game', params: {'id': game.url, lang: $store.getters.getLang}}"
                          :disabled="submitDisabled"
                      >
                          <span>{{__('Leave the Game')}}</span>
                      </BaseButton>
                  </div>


              </div>
            </div>
          </div>
<!--        </ModalDefault>-->

      <ModalRulesGame
          v-bind:game.sync="game"
          v-if="rules_game_modal"
          v-bind:rules_game_modal.sync="rules_game_modal"
      />
    </div>
</template>

<script>
    import GameIframeGame from './GameIframeGame';
    import GameIframe from './GameIframe';
    import moment from 'moment';
    // import ModalDefault from "../../modules/ModalDefault";
    import ModalRulesGame from "./ModalRulesGame";
    // import VueSlickCarousel from "vue-slick-carousel";
    // import "vue-slick-carousel/dist/vue-slick-carousel.css";
    // import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

    export default {
        name: 'GamesFrame',
        data: function() {
            return {
                iframe: null,
                game: null,
                loading: false,
                stubOrientation: false,
                id: this.$router.currentRoute.params['id'],
                room_id: this.$router.currentRoute.params['room_id'],
                battle_id: this.$router.currentRoute.params['battle_id'],
                modal_result: null,
                time_rematch: null,
                interval: null,
                submitDisabled: false,
                reloadDisabled: false,
                rules_game_modal:false,
                timer: null,
                my_emoji: [],
                my_timer: null,
                add_class_emoji: false,
                add_class_timer: null,
                focus: false,
                settings: {
                    "arrows": true,
                    "dots": false,
                    "infinite": false,
                    "slidesToShow": 14,
                    "slidesToScroll": 1,
                    "initialSlide": 0,
                    "responsive": [
                        {
                            "breakpoint": 1600,
                            "settings": {
                                "slidesToShow": 12,
                                "slidesToScroll": 1
                            }
                        },
                        {
                            "breakpoint": 1200,
                            "settings": {
                                "slidesToShow": 10,
                                "slidesToScroll": 1
                            }
                        },
                        {
                            "breakpoint": 950,
                            "settings": {
                                "slidesToShow": 8,
                                "slidesToScroll": 1
                            }
                        },
                        {
                            "breakpoint": 768,
                            "settings": {
                                "slidesToShow": 6,
                                "slidesToScroll": 1
                            }
                        },
                        {
                            "breakpoint": 500,
                            "settings": {
                                "slidesToShow": 5,
                                "slidesToScroll": 1
                            }
                        },
                        {
                            "breakpoint": 450,
                            "settings": {
                                "slidesToShow": 4,
                                "slidesToScroll": 1
                            }
                        }
                    ]
                },
                submitEmoji: true,
                arr_emoji: [
                    {
                        "id": 538591,
                        "img": '/dist/images/emoji/smile_1.gif'
                    },
                    {
                        "id": 184569,
                        "img": '/dist/images/emoji/smile_2.gif'
                    },
                    {
                        "id": 385129,
                        "img": '/dist/images/emoji/smile_3.gif'
                    },
                    {
                        "id": 871249,
                        "img": '/dist/images/emoji/smile_4.gif'
                    },
                    {
                        "id": 881237,
                        "img": '/dist/images/emoji/smile_17.gif'
                    },
                    {
                        "id": 553937,
                        "img": '/dist/images/emoji/smile_14.gif'
                    },
                    {
                        "id": 153737,
                        "img": '/dist/images/emoji/smile_15.gif'
                    },
                    {
                        "id": 657438,
                        "img": '/dist/images/emoji/smile_16.gif'
                    },
                    {
                        "id": 613903,
                        "img": '/dist/images/emoji/smile_5.gif'
                    },
                    {
                        "id": 536991,
                        "img": '/dist/images/emoji/smile_6.gif'
                    },
                    {
                        "id": 203781,
                        "img": '/dist/images/emoji/smile_7.gif'
                    },
                    {
                        "id": 901256,
                        "img": '/dist/images/emoji/smile_9.gif'
                    },
                    {
                        "id": 603571,
                        "img": '/dist/images/emoji/smile_10.gif'
                    },
                    {
                        "id": 821095,
                        "img": '/dist/images/emoji/smile_11.gif'
                    },
                    {
                        "id": 307349,
                        "img": '/dist/images/emoji/smile_12.gif'
                    },
                    {
                        "id": 296106,
                        "img": '/dist/images/emoji/smile_13.gif'
                    },
                ]

            }
        },
        watch: {
          loading(val) {
              if (val) {
                  this.timer = setTimeout(() => {
                      this.$refs.frame_loading.style.opacity = '1';
                  }, 8000)
              } else {
                  clearTimeout(this.timer);
                  this.loading = false;
              }
          }
        },
        computed: {
            auth() {
                return this.$store.state.auth.user;
            },
            next_page() {
                return this.$store.state.preference.next_page;
            }
        },
        beforeRouteUpdate (to, from, next) {
            // обрабатываем изменение параметров маршрута...
            // не забываем вызвать next()
            this.iframe = null;
            this.game = null;
            this.loading = true;
            this.modal_result = null;
            this.info(to.params.id, to.params.room_id, to.params.battle_id);
            return next();
        },
        beforeDestroy() {
            this.$echo.leave("iframe." + this.auth.session_id);
            clearInterval(this.interval);
            this.$connectWebsocket();
            clearTimeout(this.timer);
            clearTimeout(this.my_timer);
            clearTimeout(this.add_class_timer);
        },
        methods: {
            sendEmoji(item) {
                clearTimeout(this.my_timer);
                clearTimeout(this.add_class_timer);
                this.add_class_emoji = false;
                this.focus = false;

                // this.submitEmoji = false;
                let response = {
                    game_id: this.game.id,
                    room_id: this.room_id,
                    battle_id: this.battle_id,
                    smile: item.id,
                };

                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games/smile", response)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if(this.$checkAuth(response)) {
                            // setTimeout(() => {
                            //     this.submitEmoji = true;
                            // }, 5000);
                            this.$refs.modal_emoji.classList.toggle('active');
                            if (this.$refs.modal_exit.classList.contains('active')) {
                                this.$refs.modal_exit.classList.remove('active');
                            }
                            this.focus = true;

                            this.my_emoji = [];
                            let smiles = this.$cleanObject(this.arr_emoji);
                            let smile = null;
                            let index = smiles.findIndex(i => {
                                return i.id == item.id;
                            });
                            smile = smiles[index];
                            this.my_emoji.push(smile);

                            this.add_class_timer = setTimeout(() => {
                               this.add_class_emoji = true;
                                this.focus = false;
                            }, 4500),

                            this.my_timer = setTimeout(() => {
                                this.my_emoji.splice(smile,1);
                                smile = null;
                                this.add_class_emoji = false;
                            }, 5000);
                        }
                    })
                    .catch((err) => {
                        this.submitEmoji = true;
                        this.httpHandler(err);
                    });
            },

            reloadPage() {
                location.reload();
                this.reloadDisabled = true;
                return false;
            },
            openModal() {
              this.$refs.modal_exit.classList.toggle('active');
            },
            openEmoji() {
              this.$refs.modal_emoji.classList.toggle('active');
              this.focus = true;
              setTimeout(() => {
                  this.focus = false;
              },500);
            },

            sendInvitation() {
                this.submitDisabled = true;

                const formData = {
                    match_id: this.game.match_id,
                    game_id: this.game.id,
                    user_id: 0,
                    amount: this.game.amount,
                    wallet: this.game.wallet,
                    password: null,
                };

                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/games/play_on', formData)
                    .then(response=> {
                        return response.json()
                    })
                    .then((response)=> {
                        if(this.$checkAuth(response)) {
                                response= response.data;
                                clearInterval(this.interval);
                                this.submitDisabled = false;
                                this.room_id= response.room_id;
                                this.battle_id= response.battle_id;
                                this.$router.push({
                                    name: "frame",
                                    params: {
                                        id: response.game_url,
                                        room_id: response.room_id,
                                        battle_id: response.battle_id,
                                        lang: this.$store.getters.getLang,
                                    },
                                });
                                this.$store.dispatch("asyncInviteGame", []);

                            // this.$gtag.event('PlayGameDone', { 'GameID': this.game.id });
                            // if (this.$metrika) {
                            //     this.$metrika.reachGoal('PlayGameDone');
                            // }
                            this.submitDisabled = false
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            },

            gameRematch() {
                let response= {
                    game_id: this.game.id,
                    room_id: this.room_id,
                    battle_id: this.battle_id
                };
                this.submitDisabled= true;

                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/games/rematch', response)
                    .then(response=> {
                        return response.json()
                    })
                    .then((response)=> {
                        if(this.$checkAuth(response)) {
                            this.time_rematch+= 4;
                            // response= {
                            //     data: {
                            //       game_id: 22,
                            //       room_id: 23
                            //     }
                            // };
                            //
                            response= response.data;
                            // this.submitDisabled= false;
                            if(response.game_id) {
                                clearInterval(this.interval);
                                this.room_id= response.room_id;
                                this.battle_id= response.battle_id;
                                this.$router.push({
                                    name: "frame",
                                    params: {
                                        id: response.game_url,
                                        room_id: response.room_id,
                                        battle_id: response.battle_id,
                                        lang: this.$store.getters.getLang,
                                    },
                                });
                            }
                        }
                    });
            },
            info(id, room_id, battle_id){
                this.loading = true;
                let formData = {
                    game_url: id,
                    room_id: room_id,
                    battle_id: battle_id,
                };
                this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/games/game_info', formData)
                    .then(response=> {
                        return response.json()
                    })
                    .then((response)=> {
                        if(this.$checkAuth(response)) {
                            //
                            // response = {
                            //     "data": {
                            //       "id": 1,
                            //       "room_id": 123456,
                            //       "match_id": 1234,
                            //       "name": "2048 Online - Real time edition",
                            //         "game_translations": [
                            //             {
                            //                 "description": "Bomberman Description",
                            //                 "game_id": 632110,
                            //                 "lang": "en",
                            //                 "name": "Bomberman",
                            //                 "rules": "Bomberman Game control"
                            //             },
                            //             {
                            //                 "description": "Бомбермен описание",
                            //                 "game_id": 632110,
                            //                 "lang": "ru",
                            //                 "name": "Бомбермен qwqwqwqwqwqwqwqwq",
                            //                 "rules": "Бомбермен &nbsp;Game control"
                            //             }
                            //         ],
                            //       "logo": "/assets/games/l-1599220044KwESVrH81n.png",
                            //       "amount": "1.00000000",
                            //       "dev_id": "1",
                            //       "rating": "5.00",
                            //       "rating_count": "0",
                            //       "game_descriptions_id": "5",
                            //       "type": "1",
                            //       "wallet": "1",
                            //       "dev_mode": "0",
                            //       "url": "https://game-cdn.poki.com/v1/2048/index.html?url_referrer=https%3A%2F%2Fpoki.com%2F&tag=pg-v1.37.1&world=&country=DE&site_id=3&categories=7%2C35%2C72%2C230%2C400%2C823%2C891%2C1103%2C1126%2C1140%2C1143%2C1145%2C1155&v=1617969194914&game_id=26749800-1dbe-11ea-a2d8-f21898135c45&game_version_id=267489e6-1dbe-11ea-a2d8-f21898135c45",
                            //       // "url": null,
                            //       "height": "700",
                            //       "favorite": 0,
                            //       "description": {
                            //         "id": 5,
                            //         "rules": "&lt;p&gt;Соревнуйтесь в 2048 с игроками по всему миру онлайн!&amp;nbsp;&lt;/p&gt;&lt;p&gt;Правила игры: Цель игры такая же, как и в оригинальной версии 2048:&amp;nbsp;&lt;/p&gt;&lt;p&gt;При помощи стрелок передвигайте пронумерованные плитки по игровому полю, чтобы объединить их и получить плитку с большим числом. Отличие сетевой игры 2048 заключается в том, что вы играете против других игроков в режиме реального времени! - Получайте очки как можно быстрее! - Тот, кто первым соберет ячейку 2048 - автоматически выигрывает. - Во втором случае результат победителя будет определен по количеству набранных балов если у двух игроков нет вариантов сделать ход или же по истечению 5-ти минут. - Избегайте отсутствия ходов: если на поле нет пустого пространства и смежных плиток с одинаковым значением - ваш результат фиксируется и вы ожидаете пока игру не завершит ваш соперник. Особенности игры: - Только настоящие игроки, без ботов. - Комплексная античит-система. - Код игры не обфусцирован = нет вредоносного ПО. - Абсолютно бесплатно! Попробуйте применять различные тактики, чтобы стать самым умным и быстрым игроком 2048! :)&lt;/p&gt;",
                            //         "agreement": null,
                            //         "policy": null
                            //       },
                            //       "developer": {
                            //         "id": 1,
                            //         "name": "Vladyslav",
                            //         "last_name": "Volkonsky"
                            //       },
                            //       "gallery": [
                            //         {
                            //           "game_id": "1",
                            //           "sort": "0",
                            //           "file": "/assets/games/game1.png",
                            //           "type": "1",
                            //           "active": "1"
                            //         },
                            //         {
                            //           "game_id": "1",
                            //           "sort": "1",
                            //           "file": "/assets/games/g-1612886925uTr7VckaMD.jpeg",
                            //           "type": "1",
                            //           "active": "1"
                            //         }
                            //       ],
                            //       "opponent_user": {
                            //           "amount": "1.00000000",
                            //           "battle_id": "1622194663",
                            //           "game_id": "230219",
                            //           "room_id": "2116984700",
                            //           "status": "1",
                            //           "user_id": "1317572788",
                            //
                            //           "user_info": {
                            //               "bg_color": "#f84138",
                            //               "id": 1317572788,
                            //               "lang": "en",
                            //               "last_name": "qwqwqwqwqqwqwqwqwqwqw",
                            //               "location": "Ukraine",
                            //               "location_img": "/dist/images/flags/ua.png",
                            //               "name": "user2",
                            //               "online": "2021/05/28 11:37:44",
                            //               "photo": "/assets/games/game1.png",
                            //               "plays": "0",
                            //               "public_id": "1317572788",
                            //               "rating_points": "12",
                            //               "vip": "0",
                            //           }
                            //       },
                            //
                            //     },
                            //     "status": 200
                            // };
                            //
                            if (window.matchMedia('(orientation: portrait)').matches && response.data.orientation == 2 && window.screen.width < 950) {
                                this.stubOrientation = true;
                            }

                            clearInterval(this.interval);
                            this.game = response.data;
                            this.loading = false;
                            this.submitDisabled = false;
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            },
            changedFavorite() {
                this.$http.get("ajax/games/" + this.$route.params.id + "/favorite")
                    .then((response) => {
                        return response.json();
                    })
                    // .then(() => {
                    //   this.game.favorite = !this.game.favorite;
                    // })
                    .then((response)=>{
                        if(this.$checkAuth(response)) {
                            this.game.favorite = response.data.favorite
                        }
                    })
                    .catch((err) => {
                        this.httpHandler(err);
                    });
            }
        },
        created() {
            this.$leaveWebsocket();
            this.info(this.id, this.room_id, this.battle_id);
            //
            // this.modal_result= {
            //     method: 'result_game',
            //     user_id: 12,
            //     result_user: 1,
            //     amount: 3,
            //     wallet: 1,
            //     rating_points: 12,
            //     time_second: 68
            // };
            //
            //
            // this.time= 15;
            // let interval= setInterval(()=> {
            //     this.time -= 1;
            //     if(this.time <= 0) {
            //         this.$router.push({
            //             name: "game",
            //             params: {
            //                 id: this.id,
            //             },
            //         });
            //         clearInterval(interval);
            //     }
            // }, 1000);
            //
            this.$echo.join("iframe." + this.auth.session_id)
            .listen("IframeEvent", (response) => {
                this.$store.commit('updateModalNext', null);
                this.$store.commit('updateNextPage', true);
                response= response.data;
                if(response.method== 'rematch') {
                    clearInterval(this.interval);
                    this.room_id= response.room_id;
                    this.battle_id= response.battle_id;

                    this.$router.push({
                        name: "frame",
                        params: {
                            id: response.game_url,
                            room_id: response.room_id,
                            battle_id: response.battle_id,
                            lang: this.$store.getters.getLang,
                        },
                    });
                    this.$store.dispatch("asyncInviteGame", []);
                } else if(response.battle_id == this.battle_id) {
                    this.time_rematch= response.time_rematch;
                    clearInterval(this.interval);
                    this.interval= setInterval(()=> {
                        if(this.time_rematch <= moment.utc().format('X')) {
                            clearInterval(this.interval);
                            if (this.game.tournament_id) {
                                this.$router.push({
                                    name: "tournament",
                                    params: {
                                        id: this.game.tournament_id,
                                        lang: this.$store.getters.getLang,
                                    },
                                });
                            } else {
                                this.$router.push({
                                    name: "game",
                                    params: {
                                        id: this.id,
                                        lang: this.$store.getters.getLang,
                                    },
                                });
                            }

                        }
                    }, 1000);
                    this.modal_result = response;
                }
            });
        },



        mounted() {

        },

        components: {
          // ModalDefault,
          GameIframeGame,
          GameIframe,
          ModalRulesGame,
          // VueSlickCarousel,
        }
    }
</script>

<style lang="scss" scoped>
    .element::-webkit-scrollbar {
        width: 0;
    }

    /*Убрать полосу прокрутки для всей страницы*/
    ::-webkit-scrollbar {
        width: 0;
    }
    .dark {
        .wrapper-frame {
            &__loading {
                p {
                    color: #fff;
                }
            }

            .stub-orientation {
                background-color: #171827;


                &__icon {
                    background-color: #181818;
                }
                p {
                    color: #fff;
                }
            }
        }
    }

    .wrapper-frame {
        position: relative;
        height: 100vh;
        overflow: hidden;
        touch-action: none;

        .stub-orientation {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 0 16px;
            background-color: #fff;



            &__icon {
                width: 192px;
                height: 192px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 24px;
                background-color: #ECF4FF;
            }

            &__title {
                color: #002b50;
                text-align: center;
                font-weight: 500;
                font-size: 18px;
                line-height: 24px;
                margin-bottom: 12px;
            }

            &__subtitle {
                font-weight: 500;
                font-size: 14px;
                line-height: 19px;
                text-align: center;
                letter-spacing: 0.001em;
                color: #96AFD1;
                margin-bottom: 30px;
            }
        }

        &__loading {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 0 16px;

            .loading-body {
                display: flex;
                flex-direction: column;
                align-items: center;
                opacity: 0;
                transition-duration: .3s;
            }

            p {
                color: #002b50;
                margin: 0 0 30px;
                text-align: center;
                line-height: 26px;
            }
        }
    }

    /*OLD*/
    /*.modal-rematch {
        padding: 45px 30px 0;
        background: #FFFFFF;
        border-radius: 8px;

        .wrap-img {
            border-radius: 6px;
            width: 80px;
            height: 80px;
            margin: 0 auto 20px;

            img {
                border-radius: 6px;
                width: 80px;
                height: 80px;
            }
        }

        .text-win {
            !*font-family: "UniNeueBook";*!
            !*font-weight: 300;*!
            font-weight: 400;
            font-size: 24px;
            line-height: 32px;
            text-align: center;
            color: #53B331;
            margin-bottom: 20px;
        }
        .text-loose {
            font-family: "UniNeueBook";
            font-weight: 300;
            font-size: 24px;
            line-height: 28px;
            color: #FF4B55;
            margin-bottom: 26px;
        }
        .text-draw {
            font-family: "UniNeueBook";
            font-weight: 300;
            font-size: 24px;
            line-height: 28px;
            color: #96AFD1;
            margin-bottom: 26px;
        }

        .block-rating {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: #F6A401;
            margin-right: 15px;

            img {
                height: 16px;
                margin-right: 4px;
            }
        }

        .block-info {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 40px;
            !*padding-bottom: 20px;*!
            !*border-bottom: 1px solid #E7EFFF;*!

            p {
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                margin: 0 12px 0 0;
                color: #002B50;
            }
        }

        .block-coin {
            display: flex;
            align-items: center;

            &__real {
                display: flex;
                align-items: center;
                color: #00C443;
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;

                img {
                    height: 16px;
                    margin-right: 4px;
                }
            }

            &__lite {
                display: flex;
                align-items: center;
                color: #6886AF;
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;

                img {
                    height: 16px;
                    margin-right: 4px;
                }
            }
        }

        .wrap-line-time {
          overflow: hidden;
          margin: 0 -30px
        }

        .line-time {
            height: 3px;
            color: #4EBEFF;
            //margin: 0 -30px;
            animation: loading  15s linear;
        }
        @keyframes loading {
            to {
                transform: translateX(-100%);
            }
        }



        .timer {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;

            .wrapper {
                position: relative;
                background: white;
                width: 84px;
                height: 84px;
                border-radius: 50%;
                !*border: 2px solid #E7EFFF;*!
                !*margin-right: 4px;*!

                &:after {
                    content: "";
                    display: block;
                    width: 84px;
                    height: 84px;
                    border-radius: 50%;
                    background: rgba(0, 43, 80, 0.5);
                    position: absolute;
                    z-index: 999;
                }
            }

            span {
                font-family: "UniNeueBook";
                font-weight: 400;
                font-size: 30px;
                line-height: 41px;
                color: #FFFFFF;
                position: absolute;
                z-index: 1000;
            }

            img {
                width: 78px;
                height: 78px;
                border-radius: 50%;
                position: absolute;
                z-index: 998;
            }
        }

        .btn-window {
            justify-content: space-between;
            margin-bottom: 30px;
        }

        .btn-cab {
            margin-right: 20px;
        }

        .v-btn:not(.v-btn--round).v-size--default {
            height: 40px;
            min-width: 160px;
            padding: 0;
        }
    }*/

    /*NEW*/
    .modal-exit-mobile {
        display: none;
        align-items: center;
        justify-content: flex-start;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(40px);
        border-radius: 0 0 4px 4px;
        position: absolute;
        transform: translateY(-100%);
        top: 44px;
        /*width: 97%;*/
        left: 20px;
        right: 20px;
        padding: 0 20px;
        height: 60px;
        z-index: 101;
        transition: .2s;
    }

    .modal-exit-mobile.active {
        transform: translateX(0);
        transition: .2s;
    }

    .modal-emoji {
        /*display: block;*/
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(40px);
        border-radius: 4px;
        position: absolute;
        transform: translateY(-110%);
        top: 54px;
        max-width: 420px;
        /*width: 97%;*/
        /*left: 20px;*/
        right: 20px;
        padding: 10px;
        height: fit-content;
        max-height: 265px;
        overflow: auto;
        z-index: 101;
        transition: .2s;
        
        .block-notpro {
            border-radius: 0 0 4px 4px;
            position: absolute;
            z-index: +1;
            background: rgba(0, 0, 0, 0.5);
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;
            text-align: center;
            color: #fff;
            font-weight: 400;
            font-size: 20px;
            line-height: 27px;
            text-shadow: -0   -1px 0   #000,
            0   -1px 0   #000,
            -0    1px 0   #000,
            0    1px 0   #000,
            -1px -0   0   #000,
            1px -0   0   #000,
            -1px  0   0   #000,
            1px  0   0   #000,
            -1px -1px 0   #000,
            1px -1px 0   #000,
            -1px  1px 0   #000,
            1px  1px 0   #000,
            -1px -1px 0   #000,
            1px -1px 0   #000,
            -1px  1px 0   #000,
            1px  1px 0   #000;
        }

        .emoji-item {
            display: flex;
            justify-content: center;
            img {
                cursor: pointer;
                width: 50px;
                height: 50px;
                transition-duration: .3s;

                &:hover {
                    transform: scale(1.2);
                    transition-duration: .3s;
                }
            }

            img.img-disabled {
                opacity: 0.4;
            }
            
            img.img-grey {
                filter: grayscale(100%);
            }
        }
    }

    .modal-emoji.active {
        transform: translateX(0);
        transition: .2s;
    }

    .modal-rematch {
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(40px);
        border-radius: 0 0 4px 4px;
        position: absolute;
        top: 44px;
        /*width: 97%;*/
        left: 20px;
        right: 20px;
        padding: 0 20px;
        height: 100px;

        .btn-window {
            display: flex;

            .wrap-btn-rematch {
                width: 160px;
            }

            .wrap-btn-leave {
                margin-left: 12px;
                width: 160px;
            }
        }



        .block-result {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;

            &__left {
                display: flex;
                align-items: center;
            }
        }

        .text-win {
            font-size: 24px;
            line-height: 32px;
            color: #01DF72;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0;
            min-width: 230px;

            p {
                font-size: 24px;
                line-height: 32px;
                color: #FFFFFF;
                margin: 0;
            }
        }
        .text-loose {
            font-size: 24px;
            line-height: 32px;
            color: #FF5100;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0;
            min-width: 230px;

            p {
                font-size: 24px;
                line-height: 32px;
                color: #FFFFFF;
                margin: 0;
            }
        }
        .text-draw {
            font-size: 24px;
            line-height: 32px;
            color: #96AFD1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0;
            min-width: 230px;

            p {
                font-size: 24px;
                line-height: 32px;
                color: #FFFFFF;
                margin: 0;
            }
        }

        .block-info {
            display: flex;
            align-items: flex-start;
            height: 100%;
            margin-top: -2px;
            &__item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-width: 120px;
                background: rgba(0, 0, 0, 0.2);
                margin-right: 2px;
                height: 98px;

                .item-title {
                    font-size: 14px;
                    line-height: 19px;
                    color: #FFFFFF;
                    margin-bottom: 6px;
                }

                .item-subtitle {
                    display: flex;
                    align-items: center;
                    color: #EAEAEA;


                    p {
                        margin: 0 5px 0 0;
                        font-size: 18px;
                        line-height: 24px;
                        color: #EAEAEA;
                    }
                }
            }
        }

        .wrap-line-time {
            position: relative;
            overflow: hidden;
            margin: 0 -20px;
        }

        .line-time {
            height: 2px;
            background-color: #C4C4C4!important;
            animation: loading  15s linear;
        }
        @keyframes loading {
            to {
                transform: translateX(-100%);
            }
        }



        .timer {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;

            .wrapper {
                position: relative;
                background: white;
                width: 84px;
                height: 84px;
                border-radius: 50%;
                /*border: 2px solid #E7EFFF;*/
                /*margin-right: 4px;*/

                &:after {
                    content: "";
                    display: block;
                    width: 84px;
                    height: 84px;
                    border-radius: 50%;
                    background: rgba(0, 43, 80, 0.5);
                    position: absolute;
                    z-index: 999;
                }
            }

            span {
                font-family: "UniNeueBook";
                font-weight: 400;
                font-size: 30px;
                line-height: 41px;
                color: #FFFFFF;
                position: absolute;
                z-index: 1000;
            }

            img {
                width: 78px;
                height: 78px;
                border-radius: 50%;
                position: absolute;
                z-index: 998;
            }
        }
    }

    @mixin timer($item, $duration, $size, $color, $border, $hover: running) {

        #{$item} {
            width: $size;
            height: $size;
        }

        #{$item} .pie {
            width: 50%;
            height: 100%;
            transform-origin: 100% 50%;
            position: absolute;
            background: #46BCFF;
        }

        #{$item} .spinner {
            border-radius: 100% 0 0 100% / 50% 0 0 50%;
            z-index: 200;
            border-right: none;
            animation: rota $duration + s linear 1;
            animation-fill-mode: forwards;
        }

        #{$item}:hover .spinner,
        #{$item}:hover .filler,
        #{$item}:hover .mask {
            animation-play-state: $hover;
        }

        #{$item} .filler {
            border-radius: 0 100% 100% 0 / 0 50% 50% 0;
            left: 50%;
            opacity: 0;
            z-index: 100;
            animation: opa $duration + s steps(1,end) 1 reverse;
            animation-fill-mode: forwards;
            border-left: none;
        }

        #{$item} .mask {
            border-radius: 20px 0 0 20px;
            width: 50%;
            height: 100%;
            position: absolute;
            background: inherit;
            opacity: 1;
            z-index: 300;
            animation: opa $duration + s steps(1,end) 1;
            animation-fill-mode: forwards;
        }

        @keyframes rota {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        @keyframes opa {
            0% { opacity: 1; }
            50%, 100% { opacity: 0; }
        }
    }

    @include timer('.wrapper', 15, 84px, #08C, '5px solid rgba(0,0,0,0.5)');

    /*@media screen and (max-width: 1024px) {
      .wrapper-frame {
        margin-left: -240px;
      }
    }*/

    @media screen and (max-height: 660px){
        .wrapper-frame {
            touch-action: auto;
        }
    }

    @media screen and (max-width: 1024px){
        .modal-rematch {
            padding: 0 12px;
            .btn-window {
            }

            .text-draw,
            .text-loose,
            .text-win {
                font-size: 20px;
                line-height: 28px;
                min-width: 190px;

                p {
                    font-size: 20px;
                    line-height: 38px;
                }
            }

            .block-info {
                &__item {
                    padding: 0 5px;
                    .item-title {
                        font-size: 12px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 950px) {
      .modal-rematch {
          .btn-window {
            .wrap-btn-rematch {
               width: 140px;
            }

            .wrap-btn-leave {
                display: none;
            }
          }
      }
    }

    @media screen and (max-width: 768px){
        .modal-rematch {
            .block-info {
                &__item {
                    &:nth-child(1),
                    &:nth-child(2) {
                        display: none;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 550px){
        .modal-exit-mobile {
            display: flex;
            justify-content: center;
        }

        .modal-emoji {
            left: 20px;
            top: 44px;
            border-radius: 0 0 4px 4px;
            max-width: 100%;
            padding: 10px;

            .emoji-item {
                width: 11.1%;
                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }


    @media screen  and (max-width: 525px) {
        .modal-rematch {
            left: 10px;
            right: 10px;
            .btn-window {
                .wrap-btn-rematch {
                    width: 110px;
                }

                .wrap-btn-leave {
                    display: none;
                }
            }

            .text-draw,
            .text-loose,
            .text-win {
                font-size: 16px;
                line-height: 24px;
                min-width: 140px;

                p {
                    font-size: 16px;
                    line-height: 34px;
                }
            }

            .block-info {
                &__item {
                    min-width: 100px;
                    .item-title {
                        font-size: 11px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 450px){
        .modal-rematch {
            padding: 0 10px;
            .btn-window {
                .wrap-btn-rematch {
                    width: 100px;
                }
            }

            .text-draw,
            .text-loose,
            .text-win {
                font-size: 15px;
                line-height: 22px;
                min-width: 125px;

                p {
                    font-size: 15px;
                    line-height: 32px;
                }
            }
        }
        .modal-emoji {

            .emoji-item {
                width: 14.25%;
                img {

                }
            }
        }
    }

    @media screen and (max-width: 350px){
        .modal-emoji {

            .emoji-item {
                width: 16.6%;
                img {

                }
            }
        }
    }
</style>

